import { render } from "./PasswordRuleSetting.vue?vue&type=template&id=43d923ba&scoped=true"
import script from "./PasswordRuleSetting.vue?vue&type=script&lang=js"
export * from "./PasswordRuleSetting.vue?vue&type=script&lang=js"

import "./PasswordRuleSetting.vue?vue&type=style&index=0&id=43d923ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d923ba"]])

export default __exports__